import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import RepeatMarketingTheme from '@themes/RepeatMarketingTheme';
import SiteLandingPage from './SiteLandingPage';
const LandingPageScreen = () => {
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: RepeatMarketingTheme, children: _jsx(SiteLandingPage, {}) }) }));
};
export default LandingPageScreen;
